import { ConnectProto } from "@racoon/api";
import type { SortingState } from "@racoon/ui";

/**
 * The `list_filter` sort for a paged table's sort state: the sorted column's `sort_by`
 * in fields (by column id) and its direction. Undefined while nothing is sorted, or a
 * column fields lacks is, which leaves the server's default order. A paged table sorts
 * on the server: sorting the loaded rows would order only those.
 */
export const toListSort = (
  sorting: SortingState,
  fields: Readonly<Record<string, string>>,
): Pick<ConnectProto.ListFilter, "sortBy" | "sortDirection"> | undefined => {
  const [column] = sorting;
  const sortBy = column ? fields[column.id] : undefined;
  if (!sortBy) return undefined;
  return {
    sortBy,
    sortDirection: column.desc
      ? ConnectProto.SortDirection.DESCENDING
      : ConnectProto.SortDirection.ASCENDING,
  };
};
